"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var GuMember = (0, tslib_1.__importStar)(require("./guMember"));
var Login = (0, tslib_1.__importStar)(require("./login"));
var MyPage = (0, tslib_1.__importStar)(require("./myPage"));
var ClientCoupon = (0, tslib_1.__importStar)(require("./clientCoupon"));
var IntegralMall = (0, tslib_1.__importStar)(require("./integralMall"));
var Jktwx = (0, tslib_1.__importStar)(require("./jktwx"));
var DynamicCode = (0, tslib_1.__importStar)(require("./dynamicCode"));
var Coupon = (0, tslib_1.__importStar)(require("./coupon"));
var ActiveSign = (0, tslib_1.__importStar)(require("./activeSign"));
var InviteActivity = (0, tslib_1.__importStar)(require("./inviteActivity"));
var KangYang = (0, tslib_1.__importStar)(require("./kangYang"));
var NuCalm = (0, tslib_1.__importStar)(require("./nucalm"));
var BindClient = (0, tslib_1.__importStar)(require("./bindClient"));
var User = (0, tslib_1.__importStar)(require("./user"));
var Employment = (0, tslib_1.__importStar)(require("./employment"));
exports.default = {
    GuMember: GuMember,
    Login: Login,
    MyPage: MyPage,
    ClientCoupon: ClientCoupon,
    IntegralMall: IntegralMall,
    Jktwx: Jktwx,
    DynamicCode: DynamicCode,
    Coupon: Coupon,
    ActiveSign: ActiveSign,
    InviteActivity: InviteActivity,
    KangYang: KangYang,
    NuCalm: NuCalm,
    BindClient: BindClient,
    User: User,
    Employment: Employment
};
//# sourceMappingURL=index.js.map